var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link",class:[_vm.color, _vm.size]},[(_vm.to)?_c('router-link',{attrs:{"to":_vm.to,"target":_vm.target}},[_vm._t("default")],2):_c('a',{attrs:{"href":_vm.href,"target":_vm.target}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }